import Config from './configSelector';

export const IS_DEV_ENVIRONMENT = false;
export const Api = IS_DEV_ENVIRONMENT ? Config.DEV_API_URL : Config.API_URL;
export const HOST = Config.HOST_URL;
export const ACCESS_TOKEN_API = '39711613939D23844C2F700FD4A23B31C4684EB1';
export const SECOND_ACCESS_TOKEN_API = '39711613939D23844C2F700FD4A23B31C4684EB1';

export const { BRAND_NAME, SUPPORT_EMAIL, EVENT_UUID } = Config;
export const STRIPE_PUBLIC_KEY = IS_DEV_ENVIRONMENT
    ? Config.STRIPE_PUBLIC_KEY_DEV
    : Config.STRIPE_PUBLIC_KEY_LIVE;
export const HOME_PAGE_PAYPAL_REDIRECT = IS_DEV_ENVIRONMENT ? 'https://dev.gotmy.com' : 'https://gotmy.com';
export const HIDE_MOBILE_LOGIN = false;

export const disabledStartStreaming = false;
export const IS_INFLUENCER_STREAMING_ENABLED = true;
export const IS_VIEWER_STREAMING_ENABLED = true;
export const SECURE_LOGIN_BACK_URL = IS_DEV_ENVIRONMENT ? 'https://dev.gotmy.com/' : 'https://gotmy.com';
export const IS_SIGN_UP_ENABLED = true;
export const RESTRICTED_VIEWS = true;
export const INFLUENCER_ONLY_MODE = false;

export const googlePlayGotmyURL = 'https://play.google.com/store/apps/details?id=com.gotmy.app';
export const appleStoreGotmyURL = 'https://apps.apple.com/app/gotmy/id1480807998';
